var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer none"},[_vm._v(" Copyright © "),_c('a',{attrs:{"href":_vm.site_url}},[_vm._v("R&C IP WORKS, LTD.")])])}
var staticRenderFns = []

export { render, staticRenderFns }